<script lang="ts">
  import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-svelte';

  interface Props {
    label: string;
    direction: 'asc' | 'desc' | null;
    onSort: () => void;
    class?: string;
  }

  let { label, direction, onSort, class: className }: Props = $props();

  const Icon = $derived(direction === 'asc' ? ArrowUp : direction === 'desc' ? ArrowDown : ArrowUpDown);
</script>

<th
  scope="col"
  class={className}
  aria-sort={direction === 'asc' ? 'ascending' : direction === 'desc' ? 'descending' : undefined}
>
  <button type="button" class="ws-sort" onclick={onSort}>
    <span>{label}</span>
    <Icon size={16} aria-hidden="true" />
  </button>
  <!-- Phones hide the sort button with the header row, so the column keeps its name for screen readers. -->
  <span class="ws-phone-only">{label}</span>
</th>
